export const REWARD_TYPES = {
  REVIEW: "review",
  NEGATIVE_REVIEW: "negative-review",
  REFERRAL: "referral",
  ORDER: "order",
  SURVEY: "survey",
  ADMIN: "admin",
};

export const REWARD_POINTS = {
  REVIEW: 10,
  NEGATIVE_REVIEW: -10,
  REFERRAL: 100,
  ORDER: 1,
  SURVEY: 1,
};
